/** `/$org/apps/contract-intelligence/documents`: everything reviewed, by counterparty. */
import { createFileRoute } from "@tanstack/react-router";

import { CiDocumentsPage } from "../components/apps/contractIntelligence/CiDocumentsPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/documents")({
  component: CiDocumentsPage,
});
